module.exports = __webpack_public_path__ + "static/img/medicalRecordExample.d0fac190.png";